<div class="card-content"><ng-content /></div>